module.exports = __webpack_public_path__ + "img/qrcode-651.0ab9e9de.png";